export const RealmRole = {
  XTEAM: "x-team-default-roles",
  XADMIN: "x-admin-default-roles"
};
